import * as React from "react";
import { Field, reduxForm, InjectedFormProps } from "redux-form";
import { RegularField, DatePicker } from "./Fields/_Fields";
import { Validators as V } from "./Fields/Validators";
import { legalFormOptions } from "Models/Dictionary";

const NewContactDataForm = (props: InjectedFormProps) => {
  const { handleSubmit, submitting } = props;

  return (
    <div className="form form--salesman">
      <form className="form" onSubmit={handleSubmit}>
        <Field wrapperClassName={"full"} name="contactDate" component={DatePicker} label={"Data kontaktu"} placeholder={"Wybierz datę kontaktu"} validate={[V.required]} />
        <Field wrapperClassName={"full"} type="textarea" name="message" component={RegularField} label={"Opis"} placeholder={"Opis"} validate={[V.required]} />
        <button disabled={submitting} className="btn btn--main btn--big " type="submit">
          Dodaj
        </button>
      </form>
    </div>
  );
};

export default reduxForm({
  form: "newContactDataForm",
})(NewContactDataForm);



// WEBPACK FOOTER //
// ./src/components/Forms/NewContactDataForm.tsx